//
// TODO: fix this! **This is a complete hacky way to do this.**
// Only excute code below on drop designer page
//
const host = 'https://www.skyboxaudio.com';

if (window.location.href == host + '/pages/dropdesigner' || window.location.href == host + '/pages/dropdesignerthankyou') {
//drop designer
	//customize behavior of error and success messages from mailchimp after clicking subscribe button
		//select the target node
			var drop_target = document.getElementById('drop-status');
		//create an observer instance
			var observer = new MutationObserver(function(mutations) {
				mutations.forEach(function(mutation) {
					//if success, go to thank you page
						if (drop_target.innerHTML === "Thank you for subscribing! Your download link will be emailed to you within 15 minutes.") {
							drop_target.innerHTML = "";
							window.location.replace("https://www.skyboxaudio.com/pages/dropdesignerthankyou");
						}
					//if error, display instructions to login to user account
						if (drop_target.innerHTML.includes(" is already subscribed to list skybox Audio.")) {
							drop_target.innerHTML = "Drop Designer can be downloaded from your skybox Audio account page. " + "<a href='https://www.skyboxaudio.com/account'><u>Login or complete your signup here</u>.</a>";
						}
				});
			});
		//configuration of the observer:
			var config = { attributes: true, childList: true, characterData: true };
		//pass in the target node, as well as the observer options
			observer.observe(drop_target, config);
}
